import { PayoutValues, PayoutResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

export function calculatePayouts(values: PayoutValues, t?: ToolsTranslations['payout']): PayoutResult {
  const { dividendPerShare, earningsPerShare, cashFlowPerShare, freeCashFlowPerShare } = values;

  const sanitize = (n: number) => (isFinite(n) && n >= 0 ? n : NaN);
  const dps = sanitize(dividendPerShare);
  const eps = sanitize(earningsPerShare);
  const cfs = sanitize(cashFlowPerShare);
  const fcfs = sanitize(freeCashFlowPerShare);

  const payoutEarnings = eps > 0 ? (dps / eps) * 100 : null;
  const payoutCashFlow = cfs > 0 ? (dps / cfs) * 100 : null;
  const payoutFreeCashFlow = fcfs > 0 ? (dps / fcfs) * 100 : null;

  const round2 = (v: number | null) => (v === null ? null : Math.round(v * 100) / 100);

  const result: PayoutResult = {
    payoutEarningsPercent: round2(payoutEarnings),
    payoutCashFlowPercent: round2(payoutCashFlow),
    payoutFreeCashFlowPercent: round2(payoutFreeCashFlow),
    isValid: true,
  };

  if ((payoutEarnings === null) && (payoutCashFlow === null) && (payoutFreeCashFlow === null)) {
    return { ...result, isValid: false, message: t?.invalid.generic ?? 'Ogiltiga värden' };
  }

  return result;
}


